<template>
  <div class="root">
    <el-form
      ref="form"
      :model="form"
      label-width="180px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="联系人：" prop="userName">
        <el-input
          v-model="form.userName"
          placeholder="请输入联系人姓名"
        ></el-input>
      </el-form-item>

      <el-form-item label="电 话：" prop="phone">
        <el-input
          v-model="form.phone"
          placeholder="请输入联系人电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号：" prop="idcard">
        <el-input v-model="form.idcard" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="地 址：" prop="address">
        <el-input
          v-model="form.address"
          placeholder="请输入单位地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型：" prop="type">
        <!--<el-radio-group v-model="form.type">
          <el-radio :label="'1'">个人</el-radio>
          <el-radio :label="'2'">企业</el-radio>
        </el-radio-group>-->
        <!-- <el-select v-model="form.type" placeholder="请选择竞买方类型">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <div>
          <div class="selectInput" @click="showSelectInp = !showSelectInp">
            <span
              style="font-size: 18px; color: #bbb; user-select: none"
              :class="{ selectInp: form.type != '' }"
              >{{
                form.type
                  ? typeOptions[form.type - 1].label
                  : "请选择竞买方类型"
              }}</span
            >
            <i class="el-icon-arrow-down" style="font-size: 20px"></i>
          </div>
          <div class="selectInpOptions" v-if="showSelectInp">
            <div
              class="inpOptions"
              v-for="(item, index) in typeOptions"
              :key="index"
              @click="
                () => {
                  form.type = item.value;
                  showSelectInp = false;
                }
              "
            >
              <span class="">{{ item.label }}</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="
          form.type == 2
            ? '公司名称'
            : form.type == 3
            ? '合作社名称'
            : '单位名称'
        "
        prop="companyName"
        v-if="
          form.type == 2 ||
          form.type == 3 ||
          form.type == 4 ||
          form.type == 5 ||
          form.type == 6
        "
      >
        <el-input
          v-model="form.companyName"
          :placeholder="
            form.type == 2
              ? '请输入公司全称'
              : form.type == 3
              ? '请输入合作社全称'
              : '请输入单位名称'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        label="法定代表人："
        prop="companyPersonName"
        v-if="
          form.type == 2 ||
          form.type == 3 ||
          form.type == 4 ||
          form.type == 5 ||
          form.type == 6
        "
      >
        <el-input
          v-model="form.companyPersonName"
          placeholder="请输入法人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="公司性质：" prop="companyType" v-if="form.type == 2">
        <!-- <el-input v-model="form.companyType" placeholder="请输入公司性质"></el-input> -->

        <div>
          <div class="selectInput" @click="showSelectInp1 = !showSelectInp1">
            <span
              style="font-size: 18px; color: #bbb; user-select: none"
              :class="{ selectInp: form.companyType != '' }"
              >{{
                form.companyType ? form.companyType : "请选择公司类型"
              }}</span
            >
            <i class="el-icon-arrow-down" style="font-size: 20px"></i>
          </div>
          <div class="selectInpOptions" v-if="showSelectInp1">
            <div
              class="inpOptions"
              v-for="(item, index) in companyOptions"
              :key="index"
              @click="
                () => {
                  form.companyType = item.value;
                  showSelectInp1 = false;
                }
              "
            >
              <span class="">{{ item.label }}</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="注册资本(元)："
        prop="registerMoney"
        v-if="form.type == 2 || form.type == 5"
      >
        <el-input
          v-model="form.registerMoney"
          placeholder="请输入注册金额"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="营业执照号："
        prop="registerNumber"
        v-if="form.type == 2"
      >
        <el-input
          v-model="form.registerNumber"
          placeholder="请输入营业执照号"
        ></el-input>
      </el-form-item>

      <el-form-item label="银行卡号：" prop="cardno">
        <el-input v-model="form.cardno" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
      <el-form-item label="开户银行：" prop="bankaddress">
        <el-input
          v-model="form.bankaddress"
          placeholder="请输入开户银行"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="
          form.type == 2 ||
          form.type == 3 ||
          form.type == 4 ||
          form.type == 5 ||
          form.type == 6
        "
        label="法人身份证号："
        prop="companyIdCard"
      >
        <el-input
          v-model="form.companyIdCard"
          placeholder="请输入法人身份证号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item
        v-if="
          form.type == 2 ||
          form.type == 3 ||
          form.type == 4 ||
          form.type == 5 ||
          form.type == 6
        "
        label="机构信用代码："
        prop="companyCode"
      >
        <el-input
          v-model="form.companyCode"
          placeholder="请输入机构信用代码"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="联系人身份证：" prop="cardImg">
        <el-upload
          :action="uploadImgUrl"
          :headers="headers"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          accept=".png , .jpg, .jepg"
          :limit="2"
          :on-exceed="uploadExceed"
          :on-success="uploadImgSuccess"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item
        ref="fujian"
        label="上传相关附件:"
        style="height: auto; width: 100%"
        prop="fujian"
        class="fujian"
      >
        <el-upload
          :action="uploadImgUrl"
          :headers="headers"
          list-type="text"
          class="upload-demo"
          accept=".png , .jpg, .jepg"
          :on-remove="imgRemove"
          :on-error="imgError"
          :on-success="imgSuccess"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="img-text" style="font-size: 22px; font-weight: bold">
          根据《农村土地经营权流转管理办法》，上传相关报名资料及保证金打款证明(电子回单等)。
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            font-size: 20px;
            line-height: 24px;
            margin: 10px 0;
            margin-bottom: 16px;
          "
        >
          <div
            style="
              width: 18px;
              height: 18px;
              border: 1px solid #1c78ef;
              border-radius: 200px;
              position: relative;
              cursor: pointer;
            "
            @click="updateAttachment1"
          >
            <div
              v-if="selectAttachment1"
              style="
                width: 14px;
                height: 14px;
                background-color: #1c78ef;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border-radius: 200px;
                border: 0;
              "
            ></div>
          </div>
          <span style="margin-left: 8px">请阅读</span>
          <span class="attachment" @click="showAttachment1 = true"
            >网络竞价承诺函</span
          >
        </div>
        <el-dialog
          title="网络竞价承诺函"
          :visible.sync="showAttachment1"
          width="50%"
          center
          @opened="openedAttachment"
          @closed="closed"
        >
          <div class="attachmentText">
            <p style="text-indent: 2em">
              {{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}：
            </p>
            <p style="text-indent: 2em">
              本竞买方就参与“{{
                projectDetail[projectparams[$route.query.type - 1].projectName]
              }}”项目网络竞价活动作出如下承诺：
            </p>
            <p style="text-indent: 2em">
              一、本竞买方同意按照农村产权转出公告的要求，参加“{{
                projectDetail[projectparams[$route.query.type - 1].projectName]
              }}”项目网络竞价活动，并参与报价。
            </p>
            <p style="text-indent: 2em">
              二、本竞买方对 “{{
                projectDetail[projectparams[$route.query.type - 1].projectName]
              }}”
              项目和《农村产权交易所网络竞价实施办法（试行）》、《农村产权交易所收费管理办法（试行）》、《网络竞价须知》已充分了解，并自愿遵守文件中的相关规定。
            </p>
            <p style="text-indent: 2em">
              三、本竞买方已进行并完成针对本项目的尽职调查工作（包括但不限于查阅由转出方提供的本项目的档案文件），对项目标的情况已充分知晓。本竞买方自行承担包括但不限于因所获取的表达信息不全面、错误或误解等而产生的相应后果，转出标的因权属、真伪、质量或使用性能等产生的问题与天津农村产权交易所无关。
            </p>
            <p style="text-indent: 2em">
              四、本竞买方同意转出方和
              {{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}规定的出现下列情况之一保证金不再退还。
            </p>
            <p style="text-indent: 2em">
              1.产生一名竞买方时，若该竞买方未按照时间签订交易合同、未交纳交易费用的；
            </p>
            <p style="text-indent: 2em">
              2.产生两名（包含两名）以上竞买方时，若全部竞买方均未参加网络竞价，导致此次流转交易未产生有效竞买方的；
            </p>
            <p style="text-indent: 2em">
              3.被确认为本次流转交易的竞买方后，竞买方未在竞价结束次日起三个工作日内与转出方签署相关交易合同、未交纳交易费用的。
            </p>
            <p style="text-indent: 2em">
              4.采用非法手段、非法行为，进行网络竞价的；
            </p>
            <p style="text-indent: 2em">5.不按规定合同条款签约的；</p>
            <p style="text-indent: 2em">6.其他。</p>
            <p style="text-indent: 2em">
              五、本竞买方承诺在竞价成功后严格按照转出方的要求予以开发利用，且不用于非农业建设，不改变原用途，不破坏农业综合生产能力，不破坏生态环境，对于需提供开发利用规划的，及时提交规划文件。
            </p>
            <p style="text-indent: 2em">
              六、本竞买方承诺在竞价成功后按照天津农村产权交易所要求与转出方签署相关协议，并按协议约定支付交易价款及交易服务费。
            </p>
            <p style="text-indent: 2em">
              七、本竞买方承诺如遇互联网可能出现不稳定情况、网络黑客恶意攻击、以及本人操作失误等情况导致竞价无法正常报价的，所造成的损失由本竞买方承担（包括但不限于网络故障、电路故障、系统故障）。
            </p>
            <div style="display: flex; margin: 20px 0">
              <div style="flex: 1"></div>
              <!-- <div style="display: flex; flex-direction: column; width: 260px">
                <span>竞买人</span>
                <span style="text-align: center">年 月 日</span>
              </div> -->
            </div>
          </div>
          <div
            style="
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 80px;
            "
          >
            <el-button
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
              @click="
                () => {
                  this.selectAttachment1 = true;
                  this.showAttachment1 = false;
                }
              "
              type="primary"
              :disabled="this.residueTime > 0"
              >同意<span v-if="this.residueTime > 0"
                >({{ residueTime }}秒)</span
              ></el-button
            >
          </div>
        </el-dialog>
        <div
          style="
            display: flex;
            align-items: center;
            font-size: 20px;
            line-height: 24px;
          "
        >
          <div
            style="
              width: 18px;
              height: 18px;
              border: 1px solid #1c78ef;
              border-radius: 200px;
              position: relative;
              cursor: pointer;
            "
            @click="updateAttachment2"
          >
            <div
              v-if="selectAttachment2"
              style="
                width: 14px;
                height: 14px;
                background-color: #1c78ef;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border-radius: 200px;
                border: 0;
              "
            ></div>
          </div>
          <span style="margin-left: 8px">请阅读</span>
          <span class="attachment" @click="showAttachment2 = true"
            >网络竞价须知</span
          >
        </div>
        <el-dialog
          title="网络竞价须知"
          :visible.sync="showAttachment2"
          width="50%"
          center
          @opened="openedAttachment"
          @closed="closed"
        >
          <div class="attachmentText">
            <p style="text-indent: 2em">
              一、{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}《网络竞价须知》，依据《{{
                cityDetail.cityName
              }}农村产权交易信息服务网网络竞价实施办法（试行）》制定。
            </p>
            <p style="text-indent: 2em">
              二、竞买方应当在报名截止前按通知规定交纳保证金、文书费（不得代办、代缴费、每人只能投一标）、签署并向{{
                cityDetail.cityName
              }}农村产权交易信息服务网（以下简称农交所）提交本次网络竞价《网络竞价项目承诺函》等竞价文件，经{{
                cityDetail.cityName
              }}农村产权交易信息服务网审查合格后，取得竞价资格。
            </p>
            <p style="text-indent: 2em">
              竞买方应了解并接受《{{
                cityDetail.cityName
              }}农村产权交易信息服务网网络竞价实施办法（试行）》、《{{
                cityDetail.cityName
              }}农村产权交易信息服务网收费管理办法（试行）》等业务规则的全部内容。竞买方应全面了解并知悉转出方提供的农村产权转出公告披露的标的信息。
            </p>
            <p style="text-indent: 2em">
              竞买方应对所竞买的项目标的有关情况及瑕疵已做了全面的了解，对存在的法律风险进行了判断，并对可能产生的风险进行了相应的风险应对准备，且对竞价成功后的《成交通知书》及相关承包（流转）合同的签署均无异议。
            </p>
            <p style="text-indent: 2em">
              三、竞买方应于网络竞价活动开始前，登录网站 （{{
                cityDetail.cityName
              }}农村产权交易信息服务网网站），登录个人中心，打开参与竞价的项目，进行竞价。
            </p>
            <p style="text-indent: 2em">
              四、本次网络竞价标的起始价为人民币：{{
                projectDetail[projectparams[$route.query.type - 1].price]
              }}
              元。
            </p>
            <p style="text-indent: 2em">
              五、本次网络竞价采用的竞价方式（阶梯竞价）。
            </p>
            <p style="text-indent: 2em">六、本次网络竞价由竞价期。</p>
            <p style="text-indent: 2em">
              竞价期起止时间以竞价系统显示时间为准。
            </p>
            <p style="text-indent: 2em">
              七、竞买方接受转出方确定的交易条件，通过农交所的网络竞价系统进行动态递增报价，并接受将报价最高者确定为受让方的竞价方式。
            </p>
            <p style="text-indent: 2em">
              只征集到一个竞买方的，依照转出方意愿进行处理。
            </p>
            <p style="text-indent: 2em">
              八、网络竞价期间，所有报价均在农交所交易平台竞价中心即时显示，报价指令一经发出不得撤销，最终有效报价的结果以交易平台竞价系统纪录数据和成交公示为准。
            </p>
            <p style="text-indent: 2em">九、竞价保证金的处置</p>
            <p style="text-indent: 2em">
              （一）竞价时间截止，产生有效竞买方时：
            </p>
            <p style="text-indent: 2em">
              （1）被确认为本次承包（流转）土地竞买方所交纳竞价保证金的处置：被确认为本次承包（流转）土地竞买方所交纳竞价保证金转为承包（流转）保证金，按约定时间、地点签订承包（流转）合同并交纳有关费用后，竞价保证金抵顶承包（流转）费。竞买方应当在竞价结束次日起三个工作日内与转出方签署承包（流转）合同并交纳有关费用。逾期不签合同、不交纳费用的，视为主动放弃竞买资格，保证金作为转出方的损失赔偿，不再退还，划归转出方所有，并按成交金额的0%向农交所一次性支付竞价交易服务费。转出方将另行通知再次组织发包。
            </p>
            <p style="text-indent: 2em">
              （2）其他竞买方所交纳保证金的处置：其它竞买方在竞价结束次日起三个工作日内，办理退还保证金手续，如遇周六日或银行系统升级维修等特殊情况不能正常办理，则顺延办理，竞价保证金不计利息。竞买方以银行转账方式缴付竞价保证金的，其竞价保证金退回原划款账户；竞买方以现金方式缴付竞价保证金的，其竞价保证金退还其提供的银行账户。
            </p>
            <p style="text-indent: 2em">
              （二）竞价时间截止，所有竞买方均未报价导致本次网络竞价终结的，视为违约，所有竞买方交纳的竞价保证金将不予退还，划归转出方所有。
            </p>
            <p style="text-indent: 2em">
              十、竞买方应当对参与网络竞价的用户名和密码的安全性负责，任何使用竞买方用户名和密码登录进入网络竞价系统的用户，在系统中的一切行为均视为竞买方本人行为，由竞买方负责。
            </p>
            <p style="text-indent: 2em">十一、竞买方的义务</p>
            <p style="text-indent: 2em">（一）竞买方有维护竞价秩序的义务；</p>
            <p style="text-indent: 2em">
              （二）竞买方有按规定交纳各种费用的义务：
            </p>
            <p style="text-indent: 2em">
              （三）竞买方有执行发包（流转）文件的义务；
            </p>
            <p style="text-indent: 2em">
              （四）竞买方有服从工作人员指挥的义务；
            </p>
            <p style="text-indent: 2em">（五）竞买方有遵守会场纪律的义务。</p>
            <p style="text-indent: 2em">
              十二、因竞买方如下行为产生的一切后果，农交所不承担任何责任：
            </p>
            <p style="text-indent: 2em">
              1.未及时关注农交所发布的竞价活动相关信息的；
            </p>
            <p style="text-indent: 2em">
              2.所填写的信息不真实、不准确或不完整而造成注册帐户无法使用或保证金无法退还的；
            </p>
            <p style="text-indent: 2em">
              3.由于竞买方自身的终端设备和网络异常等原因导致无法正常报价的；
            </p>
            <p style="text-indent: 2em">
              4.网络竞价活动的时间以网络竞价系统服务器时间为准，由于竞买方自身终端设备时间与网络竞价服务器时间不符而导致的未按时参与报价的。
            </p>
            <p style="text-indent: 2em">
              十三、网络竞价系统因不可抗力、软硬件故障、非法入侵、恶意攻击等原因而导致系统异常、竞价活动中断的，农交所有权取消本次网络竞价活动，将视情况采取重新组织竞价、与转出方协商其他解决方案等措施，并及时将处理决定进行公告，同时农交所不承担任何责任。
            </p>
            <p style="text-indent: 2em">十四、法律责任</p>
            <p style="text-indent: 2em">
              违反发包（流转）文件规定，造成发包（流转）失败，需重新组织发包（流转）的，对违反规定的竞买方，取消再次竞买资格，并依法追究法律责任。
            </p>
            <p style="text-indent: 2em">
              对扰乱发包（流转）秩序的竞买方，制止无效的，取消其竞买资格，构成犯罪的，依法追究刑事责任。
            </p>
            <p style="text-indent: 2em">
              十五、本《网络竞价须知》有关条款的解释权归农交所所有，与本《网络竞价须知》不一致内容以本《网络竞价须知》为准，农交所有权根据相关法律、法规进行变更和修订。
            </p>
          </div>
          <div
            style="display: flex; align-items: center; justify-content: center"
          >
            <el-button
              @click="
                () => {
                  this.selectAttachment2 = true;
                  this.showAttachment2 = false;
                }
              "
              type="primary"
              :disabled="this.residueTime != 0"
              >同意<span v-if="this.residueTime != 0"
                >({{ residueTime }}秒)</span
              ></el-button
            >
          </div>
        </el-dialog>
      </el-form-item>
      <el-form-item>
        <div
          @click.prevent="changexuanze(item, index)"
          v-for="(item, index) in dataList"
          :key="item.id"
        >
          <el-checkbox label="同意" class="checkbox" v-model="item.check"
            >同意<span class="fontColor">{{ item.title }}</span>
          </el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button type="primary" @click="onSubmit">提 交</el-button>
      <!-- <el-button type="primary" @click="qingchu">清除</el-button> -->
      <el-button v-show="isShow" type="primary" @click="isShow1 = true"
        >查看账号密码</el-button
      >
    </div>
    <el-dialog
      title="账号密码信息"
      :visible.sync="isShow1"
      width="50%"
      center
      class="tanchuang"
    >
      <p style="text-indent: 2em">
        温馨提示：请记好您的账号密码，等待工作人员审核。
      </p>
      <span class="span">{{ message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShow1 = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="isShow2" width="1300px" center>
      <div class="dialog1">
        <!-- <div>{{currentItem.title}}</div> -->
        <p v-html="currentItem.content"></p>
      </div>
      <div style="text-align: center">
        <el-button type="primary" @click="agreecheng">同意</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/util/request'
import {
  auctionApply,
  getUserInfoByUserId,
  enroll,
  getProjectDetail,
} from '../api/交易项目详情.js'
import { getNeedProjectDetail } from '../api/产权需求'
import { getInvitationDetail } from '../api/招投标'
export default {
  data () {
    var validateImage = (rule, value, callback) => {
      //验证器

      if (this.fileList.length <= 0) {
        //为true代表图片在  false报错
        callback(new Error('请上传附件'))
      } else {
        callback()
      }
    }
    var uploadImageList = (rule, value, callback) => {
      //验证器
      if (this.uploadImgList.length < 2) {
        //为true代表图片在  false报错
        callback(new Error('请上传附件'))
      } else {
        callback()
      }
    }
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    let IdCard = (rule, value, callback) => {
      if (!this.IdCardRole.cnid(value))
        return callback(new Error("请输入正确的身份证号"))
      return callback()
    }
    return {
      // 查看附件详情计时器
      timer: null,
      // 详情查看剩余时间
      residueTime: 10,
      // 是否已查看附件1
      selectAttachment1: false,
      // 是否已查看附件2
      selectAttachment2: false,
      // 是否打开附件1弹窗
      showAttachment1: false,
      // 是否打开附件2弹窗
      showAttachment2: false,
      // 产权交易详情内容
      projectDetail: {},
      // 弹窗展示图片路径
      dialogImageUrl: '',
      // 是否展示弹窗
      dialogVisible: false,
      // 是否展示下拉框
      showSelectInp: false,
      showSelectInp1: false,
      // 竞买方类型列表
      typeOptions: [
        {
          label: '个人',
          value: 1,
        },
        {
          label: '企业',
          value: 2,
        },
        {
          label: '合作社',
          value: 3,
        },
        {
          label: '家庭农场',
          value: 4,
        },
        {
          label: '事业单位',
          value: 5,
        },
        {
          label: '个体工商户',
          value: 6,
        },
        {
          label: '其他',
          value: 7,
        },
      ],
      // 公司类型列表
      companyOptions: [
        {
          label: '有限公司',
          value: '有限公司',
        },
        {
          label: '股份公司',
          value: '股份公司',
        },
        {
          label: '合作企业',
          value: '合作企业',
        },
        {
          label: '其他',
          value: '其他',
        },
      ],
      wenzhang: {},
      isShow2: false,
      fileList: [],
      // 上传联系人身份证正反面文件列表
      uploadImgList: [],
      form: {
        userName: '',
        address: '',
        phone: '',
        idcard: '',
        cardno: '',
        bankaddress: '',
        project_id: '',
        companyName: '', //单位名称
        companyPersonName: '', //公司法定代表人
        companyType: '', //公司性质
        registerMoney: '', //公司注册资本
        registerNumber: '', //营业执照号
        type: '', //用户类型1：个人，2：企业,3：合作社，4：家庭农场，5：事业单位，6：个体工商户，7：其他
        companyIdCard: '', //法人身份证号
        //companyCode: "", //机构信用代码
        cardImg: '', //联系人身份证正反面
      },
      projectparams: [
        {
          price: "amount",
          projectName: "projectName"
        },
        {
          price: "dealAmount",
          projectName: "projectname"
        },
        {
          price: "price",
          projectName: "projectname"
        },
      ],
      rules: {
        userName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fff]*$/, message: '姓名只能输入输入中文', trigger: 'blur' },

        ],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        companyIdCard: [
          { required: true, trigger: 'blur', message: '请输入法人身份证号' },
          { validator: IdCard, trigger: "blur" },
        ],
        // companyCode: [
        //   { required: true, trigger: "blur", message: "请输入机构信用代码" },
        // ],
        cardImg: [
          {
            required: true,
            validator: uploadImageList,
            message: '请上传联系人身份证正反面',
          },
        ],
        fujian: [
          { required: true, validator: validateImage, trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入单位地址', trigger: 'blur' },
        ],
        phone: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: IdCard, trigger: "blur" },
        ],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        cardno: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' },
        ],
        bankaddress: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '请输入公司全称', trigger: 'blur' },
        ], //单位名称
        companyPersonName: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' },
        ], //公司法定代表人
        companyType: [
          { required: true, message: '请输入公司性质', trigger: 'blur' },
        ], //公司性质
        registerMoney: [
          { required: true, message: '请输入注册金额', trigger: 'blur' },
        ], //公司注册资本
        registerNumber: [
          {
            required: true,
            message: '请输入营业执照号',
            trigger: 'blur',
          },
        ], //营业执照号
      },
      message: '',
      isShow: false,
      isShow1: false,
      dataList: [],
      currentIndex: 0,
      currentItem: {},
      uploadImgUrl: '/prod-api/common/upload', // 上传的图片服务器地址
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        deptId: this.cityDetail.deptId,
      },
    }
  },
  async created () {
    enroll().then((res) => {
      this.dataList = res.data.data
    })
    this.dataList.forEach((item) => {
      item.check = false
    })
    console.log(this.dataList)

    await getUserInfoByUserId().then((res) => {
      this.form = res.data.data
      console.log('this.form', this.form)
      if (!this.$route.query.id) {
        this.$message.error('参数错误')
        return
      }
      this.form.projectId = this.$route.query.id
      if (this.$route.query.type == 1) {
        getInvitationDetail({ id: this.form.projectId }).then((res) => {
          this.projectDetail = res.data.data
        })
      } else if (this.$route.query.type == 2) {
        getProjectDetail({ id: this.form.projectId }).then((res) => {
          this.projectDetail = res.data.data
        })
      } else if (this.$route.query.type == 3) {
        getNeedProjectDetail({ id: this.form.projectId }).then((res) => {
          this.projectDetail = res.data.data
        })
      }
      if (!this.form.type) {
        this.form.type = '1'
      }

      this.$forceUpdate()
    })
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    // 附件详情打开事件
    openedAttachment () {
      this.timer = setInterval(() => {
        this.residueTime--
        if (this.residueTime == 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 附件详情关闭事件
    closed () {
      this.residueTime = 10
      clearInterval(this.timer)
    },
    // 附件1单选框点击事件
    updateAttachment1 () {
      if (this.selectAttachment1) {
        this.selectAttachment1 = !this.selectAttachment1
      } else {
        this.showAttachment1 = true
      }
    },
    // 附件2单选框点击事件
    updateAttachment2 () {
      if (this.selectAttachment2) {
        this.selectAttachment2 = !this.selectAttachment2
      } else {
        this.showAttachment2 = true
      }
    },
    uploadImgSuccess (file, fileList) {
      // console.log('file', file)
      // console.log('fileList', fileList)
      // console.log('this.uploadImgList before push', this.uploadImgList)
      this.uploadImgList.push(fileList)
      // console.log('this.uploadImgList then push', this.uploadImgList)
    },
    uploadExceed () {
      this.$message.error('上传文件超过文件最大个数')
    },
    handleRemove (file, fileList) {
      // console.log("handleRemove.fileList", fileList)
      this.uploadImgList = [...fileList]
      // console.log('this.uploadImgList', this.uploadImgList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    changexuanze (item, index) {
      if (item.check) {
        this.dataList[index].check = false
        // item.check = false
      } else {
        this.currentItem = item //当前点击哪一条协议
        this.currentIndex = index

        this.isShow2 = true
        this.dataList[index].check = false
      }
      this.dataList = JSON.parse(JSON.stringify(this.dataList))
      console.log(this.dataList)
    },
    //点击同意合同
    agreecheng () {
      this.isShow2 = false
      this.dataList[this.currentIndex].check = true
      console.log(this.dataList)
    },
    httpRequest () { },
    qingchu () {
      this.$refs.form.resetFields()
      // this.$refs['form'].clearValidate();
    },
    onSubmit () {
      let now = new Date()
      let applyStartTime = new Date(
        this.projectDetail.releaseRecord.applyStartTime
      )
      let applyStopTime = new Date(
        this.projectDetail.releaseRecord.applyStopTime
      )
      console.log(now.getTime() < applyStartTime.getTime())
      console.log(now.getTime() > applyStopTime.getTime())
      if (
        now.getTime() > applyStopTime.getTime()
      ) {
        this.$message.error('不在报名时间内')
        return
      }
      let flag = this.dataList.every((item) => item.check)
      if (!flag) {
        this.$message.warning('请阅读')
        return
      }
      if (!this.selectAttachment1) {
        this.$message.error('请阅读网络竞价承诺函')
        return
      } else if (!this.selectAttachment2) {
        this.$message.error('请阅读网络竞价须知')
        return
      }
      if (this.form.type == 1) {
        this.form.companyName = ''
        this.form.companyPersonName = '' //公司法定代表人
        this.form.companyType = '' //公司性质
        this.form.registerMoney = '' //公司注册资本
        this.form.registerNumber = '' //营业执照号
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.uploadImgList.length < 2) {
            this.$message.error('请上传身份证正反面(2张)')
            return
          }
          this.form.cardImg = this.uploadImgList.map((item) => item.response.fileUrls[0]).join(',')
          console.log('this.form.cardImg', this.form.cardImg)
          if (this.fileList.length > 0) {
            this.form.fileId = this.fileList
              .map((item) => item.response.fileUrls[0])
              .join(',')
          } else {
            this.form.fileId = ''
          }
          this.form.userType = this.form.type
          this.form.realname = this.form.userName
          this.form.projectType = this.$route.query.type
          this.form.status = 1
          console.log('this.form', this.form)
          auctionApply(this.form).then((res) => {
            // 注册提示
            if (res.data.code == 200) {
              this.$message({
                message: '提交成功',
                type: 'success',
              })
              this.fileList = []
              this.$refs.form.resetFields()
              this.$router.back()
            } else {
              this.$message({
                message: '提交失败',
                type: 'error',
              })
            }
          })
        } else {
          this.$message({
            message: '必填信息不能为空',
            type: 'warning',
          })
          return false
        }
      })
    },
    imgSuccess (res, file, fileList) {
      let _this = this
      this.fileList = fileList

      this.$refs.form.clearValidate('fujian')
    },
    //删除图片
    imgRemove (file, fileList) {
      this.fileList = fileList
    },
    // 上传失败
    imgError (res) {
      this.$message({
        type: 'error',
        message: '附件上传失败',
      })
    },
  },
}
</script>

<style>
.el-dialog {
  border-radius: 5px !important;
  font-size: 24px;
  margin-top: 10vh !important;
}

.el-dialog__header {
  background: #1890ff;
  border-radius: 5px 5px 0 0;
  text-align: center;
}

.el-dialog__title {
  color: #fff !important;
  margin: 0 auto;
  display: inline-block;
  font-size: 24px;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
</style>

<style scoped>
.attachmentText {
  overflow: auto;
  height: 650px;
  max-height: 900px;
  padding: 0 50px;
  font-size: 22px;
  line-height: 30px;
}

.attachment {
  margin-left: 4px;
  color: #1c78ef;
  border-bottom: 1px solid #1c78ef;
  padding-bottom: 0;
  line-height: 24px;
  cursor: pointer;
}

.selectInpOptions {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 46px;
  left: 0;
  z-index: 9999;
  background-color: #fff;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 2px 2px 10px 2px #ddd;
}

.selectInput {
  border: 1px solid #ddd;
  padding: 0 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
}

.inpOptions {
  width: 100%;
  user-select: none;
  font-size: 16px;
}

.selectInp {
  color: #000 !important;
}

.dialog1 {
  min-height: 500px;
  font-size: 20px;
  zoom: 1.3;
  /* width: 1000px; */
  /* text-align: left; */
}

.checkbox {
  zoom: 170%;
}

.fontColor {
  color: #1c78ef;
  margin-left: 5px;
}

.img-text {
  font-size: 20px;
  width: 100%;
  color: #666;
}

.root {
  /* min-height: 1180px; */
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 55px 260px 80px 260px;
  width: 1300px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.root /deep/ .el-input {
  font-size: 20px;
}

.root /deep/ .el-upload-list__item {
  font-size: 20px;
}

.root /deep/ .el-checkbox__inner::after {
  width: 5px;
}

/* .root /deep/ .el-checkbox__label{
  font-size: 20px;
} */
.root /deep/ .el-form-item__error {
  font-size: 16px;
}

.root /deep/ .el-radio__label {
  font-size: 22px;
}

.form {
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.form .el-form-item {
  width: 40%;
}

.el-form-item /deep/ .el-form-item__label {
  height: 40px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
}

.el-form-item /deep/ .el-input__inner {
  height: 40px;
}

.el-form-item {
  margin-bottom: 36px;
}

.el-form-item /deep/ .el-radio-group {
  scale: 1.5;
  margin-left: 40px;
}

.el-textarea /deep/ .el-textarea__inner {
  height: 300px;
}

.btns {
  text-align: center;
}

.root .el-button {
  font-size: 20px;
}

.btns .el-button {
  width: 260px;
  height: 60px;
  font-size: 30px;
  text-align: center;
}

.zhuanrang {
  width: auto;
  height: 40px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
  letter-spacing: 5px;
}

.tanchuang >>> .el-dialog__header {
  /* padding: 20px 20px 10px; */
  padding: 0;
  background-color: #2187ff;
}

.tanchuang >>> .el-dialog__header .el-dialog__title {
  color: white;
  font-size: 24px;
}

.tanchuang >>> .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.tanchuang p {
  color: red;
  font-size: 28px;
  padding-bottom: 20px;
}

.tanchuang .span {
  color: #333333;
  font-size: 18px;
}
</style>
